import {makeRequest, makeRequestPut, makeRequestGet} from '../../Services/API';

export function getStatusNegocio(language) {
    return makeRequestGet(`/backend/negocio/getStatus/${language}`);
}
export function getMotivosPerdaNegocio(language) {
    return makeRequestGet(`/backend/negocio/getMotivosPerdaNegocio/${language}`);
}
